export const EXTERNAL_LINKS = {
  APP_ANDROID:
    'https://play.google.com/store/apps/details?id=co.blocksite&utm_source=Ext_opt_pg&utm_campaign=Extension',
  APP_IOS:
    'https://apps.apple.com/us/app/blocksite-block-apps-focus/id1474967653',
  PRIVACY_POLICY: 'https://blocksite.co/privacy',
  TERMS_OF_SERVICE: 'https://blocksite.co/terms',
  GOOGLE_FAVICON_API: 'https://www.google.com/s2/favicons',
} as const;

export const RATE_US_URLS = {
  CHROME:
    'https://chromewebstore.google.com/detail/blocksite-block-websites/eiimnmioipafcokbfikbljfdeojpcgbh/reviews',
  EDGE: 'https://microsoftedge.microsoft.com/addons/detail/blocksite-block-websites/lbnblmjlpifpfpefbcgefbhnlcnnjgjk',
} as const;

export const PLATFORM_LINKS = {
  EXTENSION_CHROME_STORE:
    'https://chromewebstore.google.com/detail/blocksite-block-websites/eiimnmioipafcokbfikbljfdeojpcgbh?hl=en',
  EXTENSION_EDGE_STORE:
    'https://microsoftedge.microsoft.com/addons/detail/blocksite-block-websites/lbnblmjlpifpfpefbcgefbhnlcnnjgjk',
  EXTENSION_FIREFOX_STORE:
    'https://addons.mozilla.org/en-US/firefox/addon/blocksite',
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=co.blocksite',
  APP_STORE_IOS: 'https://apps.apple.com/us/app/blocksite/id1474967653',
  APP_STORE_SAFARI:
    'https://apps.apple.com/us/app/blocksite-block-sites-focus/id6743401868?mt=12',
} as const;

export const STORE_RATINGS = {
  CHROME: 4.5,
  PLAY_STORE: 4.1,
  APP_STORE: 4.5,
} as const;
